import React from "react";
import InvolvementRoleTypeService from "../../../../services/InvolvementRoleTypeService";
import InvolvementRoleTypes from "./InvolvementRoleTypes";
import TableUtils from "../../../core/Table/TableUtils";
import { labels } from "../../../../localization/labels";
import { Comparator } from "react-bootstrap-table2-filter";
import PathUtil from "../../../../utils/PathUtil";
import { paths } from "../../../paths";
import TableComponentWithDialog from "../../page/TableComponentWithDialog";
import { withKeycloak } from "@react-keycloak/web";

class RoleTypesContainer extends TableComponentWithDialog {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state
    };
    this.involvementRoleTypeService = new InvolvementRoleTypeService(
      this.keycloak
    );
  }

  columns = this.initColumns([
    {
      dataField: "id",
      text: labels.id,
      sort: true,
      classes: "column-id",
      headerClasses: "column-header-id-filtered",
      headerFormatter: this.formatHeader,
      filter: TableUtils.textFilter(labels.id, Comparator.EQ)
    },
    {
      dataField: "name",
      text: labels.name,
      sort: true,
      formatter: TableUtils.textFormatter,
      headerClasses: "column-header-filtered",
      headerFormatter: this.formatHeader,
      filter: TableUtils.textFilter(labels.name)
    },
    {
      dataField: "description",
      text: labels.description,
      formatter: TableUtils.textFormatter,
      sort: true,
      headerClasses: "column-header-filtered",
      headerFormatter: this.formatHeader,
      filter: TableUtils.textFilter(labels.description)
    }
  ]);

  getComponentTitle = () => {
    return labels.InvolvementRoleTypes;
  };

  loadData = pageInfo => {
    this.prepareCall(
      this.involvementRoleTypeService.getEntities(
        pageInfo,
        this.sortInfo,
        this.onDataLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  componentDidUpdate() {
    this.shouldResetFilters = true;
    super.componentDidUpdate();
  }

  onRowClick = (_, row) => {
    const itemPath = PathUtil.adminItemsPath(
      { path: paths.INVOLVEMENTROLETYPES },
      { path: paths.DETAIL, id: row.id }
    );
    this.changePath(itemPath, row.name);
  };

  handleCreate = () => {
    const itemPath = PathUtil.adminItemsPath(
      { path: paths.INVOLVEMENTROLETYPES },
      { path: paths.DETAIL }
    );
    this.changePath(itemPath, labels.involvementRoleType);
  };

  onDeleteData = entity => {
    this.prepareCall(
      this.involvementRoleTypeService.deleteEntity(
        entity,
        this.onDataDeleteResponse,
        this.onDeleteSuccessMessage,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  render() {
    return (
      <InvolvementRoleTypes
        {...this.renderProps()}
        cellEditProps={this.cellEditProps}
        handleCreate={this.handleCreate}
        onRowClick={this.onRowClick}
      />
    );
  }
}

export default withKeycloak(RoleTypesContainer);
